import * as React from 'react';

class StringUtils {
  public static nl2brString(text: string): string {
    const regex = /(\n)/g;

    return text
      .split(regex)
      .map((line) => {
        if (line.match(regex)) {
          return `<br />`;
        }
        return line;
      })
      .join('');
  }

  public static simpleFormat(text: string) {
    const regex = /\r?\n/g;

    return (
      <React.Fragment>
        {text.split(regex).map((p: string, index: number) => (
          <p key={index}>{p ? p : <br />}</p>
        ))}
      </React.Fragment>
    );
  }
}

export default StringUtils;
